module.exports = __webpack_public_path__ + "img/NTUA_LOGO.7a5b739d.svg";